import React from 'react'
import './paraeff.css'

const ParaEff = () => {
  return (
    <div className="main_pe">
    <div className="sub_main_pe">



        <div className="photos_sec_pe"> 
        <div class="child1">
<img src="	https://s3-us-west-2.amazonaws.com/handel-architects/images/_regular/01.092.11.003.jpg"/>
        </div>
        <div class="child2">
        <img src="https://s3-us-west-2.amazonaws.com/handel-architects/images/_regular/01.082.08.001.jpg"/>

        </div>
        </div>





        <div className="text_sec_pe">
            <div className="hd"><h6>MEET W-D-A</h6></div>
            <div className="desc">
           <div className="fancy"><h2>Influential</h2></div> 
           <div className="normal"><h2>and Impactful.</h2></div>  
            </div>
            <div className="para"><p>Architecture Hub is made up of architects, designers and tradesmen. We know how to craft more than magnificent homes—we are experienced in crafting life experiences. We are committed to understanding our clients' dreams, to creating their vision, and to delivering beyond.</p></div>
        </div>
    </div>
    <div className="margin_pe">
       <div class="parallax">
        <div class="parallax-inner">
         
        </div>
       </div>
</div>
<div className="team_sec_pe">

        <div className="heading_team">
            OUR TEAM
        </div>
        <div className="divider_kr_intro">  </div>
        <div class="container">
  <div class="box">
    <div class="imgBx">
      <img src="https://arcstudio.liquid-themes.com/wp-content/uploads/2022/05/team-1@2x1.jpg" loading="lazy"/>
    </div>
    <div class="content">
      <h2>Alex Martinez</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.</p>
      <a href="#">Read More →</a>
    </div>
  </div>
  <div class="box">
    <div class="imgBx">
      <img src="https://arcstudio.liquid-themes.com/wp-content/uploads/2022/05/img-2@2x-11.jpg" loading="lazy"/>
    </div>
    <div class="content">
      <h2>Alex Martinez</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.</p>
      <a href="#">Read More →</a>
    </div>
  </div>
  <div class="box">
    <div class="imgBx">
      <img src="https://arcstudio.liquid-themes.com/wp-content/uploads/2022/05/team-2@2x1.jpg" loading="lazy"/>
    </div>
    <div class="content">
      <h2>Alex Martinez</h2>
      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
        tempor incididunt ut labore et dolore magna aliqua.</p>
      <a href="#">Read More →</a>
    </div>
  </div>

</div>
    </div>


    <div className="end">
        <div className="end1">
            <div className="hd"><h1>10+</h1></div>
            <div className="para"><span>Years of experience. Urban design draws together the many strands of place-making,</span></div>
        </div>
        <div className="end1">
            <div className="hd"><h1>90%</h1></div>
            <div className="para"><span>Average. Urban design draws together the many strands of place-making, environmental</span></div>
        </div>
        <div className="end1">
            <div className="hd"><h1>100m</h1></div>
            <div className="para"><span>Investment. Urban design draws together the many strands of place-making, environmental</span></div>
        </div>
    </div>


    </div>
  )
}

export default ParaEff